var $217b78056fce917f$exports = {};
$217b78056fce917f$exports = {
    "dismiss": `Atmesti`
};


export {$217b78056fce917f$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
